import { Button } from "@/components/ui/button";
import { useArrayInputV2 } from "./hook/use-array-input-v2";
import { ArrayList /* SearchInput */ /* SearchInput */ } from "./toolkit";
import { BulkEdit } from "./toolkit/bulk-edit";
import { CheckIcon, FullscreenIcon, XIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const ArrayInputV2 = ({
  value,
  onChange,
  placeholder,
  validation,
  message,
  separator,
  label,
}: any) => {
  const {
    list,
    manageList,
    search,
    error,
    bulkEdit,
    bulkEditContent,
    itemText,
  } = useArrayInputV2({
    value,
    onChange,
    validation,
    message,
    separator,
  });
  return (
    <div className="relative">
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-start">
          {label}

          {bulkEdit ? null : (
            <Button
              type="button"
              variant={"outline"}
              className="ml-2 p-1 w-auto h-auto hidden"
              size={"icon"}
              onClick={() =>
                manageList({ type: "bulk-edit", payload: { data: "" } })
              }
            >
              <FullscreenIcon />
            </Button>
          )}
        </div>
        <div className="text-right">
          {error && (
            <p className="text-red-500 text-xs font-bold  right-0">{error}</p>
          )}
        </div>
      </div>

      {/* <SearchInput
        placeholder={placeholder}
        manageList={manageList}
        itemText={itemText}
        error={error}
        bulkEdit={bulkEdit}
      /> */}
      {bulkEdit ? (
        <div className="relative">
          <BulkEdit
            value={bulkEditContent}
            manageList={manageList}
            placeholder={placeholder}
          />
          <div className="absolute right-2 top-2 flex items-center gap-2">
            <Button
              size={"icon"}
              variant={"default"}
              className={cn(" text-slate-100 ")}
              type="button"
              onClick={() =>
                manageList({ type: "bulk-edit", payload: { data: "" } })
              }
            >
              <CheckIcon className={cn("scale-12")} />
            </Button>
            <Button
              size={"icon"}
              variant={"outline"}
              className={cn("border-red-400 text-red-500 ")}
              type="button"
              onClick={() =>
                manageList({ type: "cancel-bulk-edit", payload: { data: "" } })
              }
            >
              <XIcon className={cn("scale-12")} />
            </Button>
          </div>
        </div>
      ) : (
        <ArrayList
          list={list}
          manageList={manageList}
          search={search}
          placeholder={placeholder}
          itemText={itemText}
          error={error}
          bulkEdit={bulkEdit}
        />
      )}
    </div>
  );
};
